import SmartBoxTraining from '@/pages/training/smartbox'

export default SmartBoxTraining
